import { createFeatureSelector, ActionReducerMap } from "@ngrx/store";
import { IEntityState, buildFeatureState } from "@briebug/ngrx-auto-entity";
import { Documentation } from "./documentation.model";

export interface IDocumentationState {
    documentation: IEntityState<Documentation>;
}

export const DOCUMENTATION = "documentation";

export const documentationState =
    createFeatureSelector<IDocumentationState>(DOCUMENTATION);

export const {
    initialState: initialDocumentationState,
    selectors,
    facade: documentationFacadeBase,
} = buildFeatureState(Documentation, DOCUMENTATION, documentationState);

export function documentationReducer(
    state = initialDocumentationState
): IEntityState<Documentation> {
    return state;
}

export const documentationReducers: ActionReducerMap<IDocumentationState> = {
    documentation: documentationReducer,
};
